// Owner-approved Arctic Plate visual assets.
// This Alaska landscape is a real National Park Service photograph from
// Denali National Park and Preserve, distributed as U.S. public-domain media.
export const APPROVED_ALASKA_LANDSCAPE =
  "https://commons.wikimedia.org/wiki/Special:Redirect/file/Reflection_Pond_is_a_popular_spot_to_capture_a_mirror_image_of_Denali_%282d26d223-1dd8-b71c-07c9-23f9b774bbb9%29.jpg?width=1600";

// Exact owner-supplied mountain lake for kitchen workspace backgrounds.
export const APPROVED_KITCHEN_LANDSCAPE = "/customer-final/kitchen-landscape.jpg";

export function kitchenLandscapeImage(value) {
  const image = String(value || "");
  return !image || image === APPROVED_ALASKA_LANDSCAPE || image === APPROVED_ALASKA_LANDSCAPE.split("?")[0]
    ? APPROVED_KITCHEN_LANDSCAPE
    : image;
}
